<template>
  <div class="container">
    <contacts-datatable />
  </div>
</template>

<script>
import ContactsDatatable from "./contacts_datatable/Index.vue";

export default {
  name: "CentralDispatchTrackerContacts",
  components: { ContactsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
